import { apiFetch } from '../utils/api';

const getRecipes = async () => {
    try {
      const response = await apiFetch('/api/recipes');
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      const data = await response.json();
      return data;
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
      throw error;
    }
  };

  const getRecipeById = async (id) => {
    try {
      const response = await apiFetch(`/api/recipes/${id}`);
      if (!response.ok) {
        throw new Error('Network response was not ok');
      }
      return await response.json();
    } catch (error) {
      console.error('There was a problem with the fetch operation:', error);
      throw error;
    }
  };
  
  export { getRecipes, getRecipeById };
  